import { RevToggleButtonType } from "@revmatics/catalyst";
import { SelectOption } from "@revmatics/catalyst";

export const mediaPlanToggleBtnData: RevToggleButtonType = [
  { id: "kpi_details", title: "KPI Details" },
  { id: "monthly", title: "Monthly" },
];

export const funnelDepthSelectData: SelectOption[] = [
  { value: "awareness", label: "Awareness (T)" },
  { value: "consideration", label: "Consideration (M)" },
  { value: "conversion", label: "Conversion (B)" },
];

export const primaryDimensionSelectData: SelectOption[] = [
  { value: "channels", label: "Channels" },
  { value: "platforms", label: "Platforms" },
];

export const kpiFieldNameData: { [key: string]: string } = {
  projected_cpm: "Projected CPM",
  roas: "ROAS",
  ctr: "CTR",
  projected_roas: "Projected ROAS",
  projected_revenue: "Projected Revenue",
  cac: "CAC",
  revenue: "Revenue",
  clicks: "Clicks",
  cpc: "CPC",
  spend: "Spend",
  projected_cpc: "Projected CPC",
  projected_clicks: "Projected Clicks",
  budget: "Budget",
  cpm: "CPM",
  projected_cac: "Projected CAC",
  projected_ctr: "Projected CTR",
};
